import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './css.css'


import 'ant-design-vue/dist/antd.css';
import { message } from 'ant-design-vue'
Vue.prototype.$message = message

import { Input,Button,Popconfirm,ConfigProvider,Modal,Carousel,Checkbox,Select,Table,Rate,Anchor,Icon,Divider,Popover,Space,Spin,Pagination,Dropdown,Menu } from 'ant-design-vue';
Vue.use(Input)
Vue.use(Popconfirm)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Table)
Vue.use(Rate)
Vue.use(Anchor)
Vue.use(Icon)
Vue.use(Divider)
Vue.use(Popover)
Vue.use(Space)
Vue.use(Spin)
Vue.use(Pagination)
Vue.use(ConfigProvider)
Vue.use(Carousel)
Vue.use(Modal)
Vue.use(Button)
Vue.use(Dropdown)
Vue.use(Menu)



// 这里省略其他代码
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$message = message

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
